/** SpringArm3D parser: the Node3D transform surface plus `spring_length`. */
import { parseNode3D } from '../../../base/node3d/parser';
import { writtenScalarSlotValue } from '../../../../godot/variant/variantBool.js';
export function parseSpringArm3D(heading, properties) {
    return {
        ...parseNode3D(heading, properties),
        spring_length: writtenScalarSlotValue(properties.spring_length),
    };
}
//# sourceMappingURL=parser.js.map